import { render, staticRenderFns } from "./TheCategoriesItem.vue?vue&type=template&id=0ea400e2&"
import script from "./TheCategoriesItem.vue?vue&type=script&lang=js&"
export * from "./TheCategoriesItem.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoriesItem.vue?vue&type=style&index=0&id=0ea400e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports